import i18n from 'i18next';

export function LanguageHelper(path) {

    return i18n.t(path);

}